module.exports = __webpack_public_path__ + "static/media/badger-honey.9080c156.svg";